export const canDelete = (rowStatus, voucherSubmissionStatus) => {
  // Cannot delete from paid vouchers
  if (voucherSubmissionStatus === 'Paid') return false;

  const normalizedRowStatus = (rowStatus || '')
    .toString()
    .toUpperCase()
    .replace(/\s+/g, '_');
  const normalizedVoucherStatus = (voucherSubmissionStatus || '').toString();

  if (normalizedRowStatus === 'NOT_SUBMITTED') return true;

  if (
    normalizedRowStatus === 'SUBMITTED' &&
    normalizedVoucherStatus === 'Submitted'
  ) {
    return true;
  }

  return false;
};

// Returns the message of the first pair whose condition is true, or undefined.
// Callers order pairs so the permission reason comes first.
export const getFirstMatchingReason = (pairs) => {
  return pairs.find(({ condition }) => condition)?.message;
};

export const canEditApprovedAmount = (hasVariance, isReadOnly, canManage) =>
  hasVariance && !isReadOnly && canManage;
